import { render, staticRenderFns } from "./IntegralOwnOrder.vue?vue&type=template&id=87d03a7a&scoped=true"
import script from "./IntegralOwnOrder.vue?vue&type=script&lang=js"
export * from "./IntegralOwnOrder.vue?vue&type=script&lang=js"
import style0 from "./IntegralOwnOrder.vue?vue&type=style&index=0&id=87d03a7a&prod&scoped=true&lang=css"
import style1 from "./IntegralOwnOrder.vue?vue&type=style&index=1&id=87d03a7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d03a7a",
  null
  
)

export default component.exports